import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import { PassportKnmActionsEnum } from '../enums/PassportKnmActionsEnum';
import { IPassportKnmState } from '../interfaces/IPassportKnmState';
import { PassportKnmAction } from '../types/PassportKnmAction';

const initialState: IPassportKnmState = {};

export function passportKnmReducer(state = initialState, action: PassportKnmAction): IPassportKnmState {
  switch (action.type) {
    case PassportKnmActionsEnum.PASSPORT_KNM_SET_DATA: {
      const { data } = action.payload;
      return {
        ...state,
        data,
      };
    }
    case PassportKnmActionsEnum.PASSPORT_DECISION_SET_DATA: {
      const { data } = action.payload;
      return {
        ...state,
        dataDecision: data,
      };
    }
    case PassportKnmActionsEnum.PASSPORT_KNM_SET_ERROR_STATUS: {
      const { errorStatus } = action.payload;
      return {
        ...state,
        errorStatus,
      };
    }
    default:
      return state;
  }
}

export const getPassportKnmData = (state: IRootState) => state.passportKnm.data;
export const getPassportKnmDataDecision = (state: IRootState) => state.passportKnm.dataDecision;
export const getPassportKnmErrorStatus = (state: IRootState) => state.passportKnm.errorStatus;
